import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function FinancialInventoryReports(){return <CompanyReportScreen kind="financial"/>;}
